import GetPrototypeModulesListRequestModelBase from '../_generated/modelBases/get-prototype-modules-list-request-model-base';

export default class GetPrototypeModulesListRequestModel extends GetPrototypeModulesListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
